var Overlay = (function () {

  function Overlay(name, leafletMap, leafletLayer, group) {
    this.name = name;
    this.map = leafletMap;
    this.layer = leafletLayer;
    this.eventHandlers = [];
    this.group = group;
  };

  Overlay.prototype.addLayer = function (layer) {
    if (layer) this.layer.addLayer(layer);
    return this;
  };

  Overlay.prototype.addLayers = function (layers) {
    for (var i = 0; i < layers.length; ++i) {
      if (layers[i]) this.layer.addLayer(layers[i]);
    }
    return this;
  };

  Overlay.prototype.clearLayers = function () {
    this.layer.clearLayers();
    return this;
  };

  Overlay.prototype.setUrl = function(url) {
    this.layer.setUrl(url);
    return this;
  };

  Overlay.prototype.fit = function() {
    try {
      this.map.fitBounds(this.layer.getBounds());
    } catch (ex) {
    }
    return this;
  };

  Overlay.prototype.show = function () {
    if (!this.isShown) {
      this.map.addLayer(this.layer);
      this.isShown = true;
      handleEvent('show', this);
    }
    return this;
  };

  Overlay.prototype.hide = function () {
    if (this.isShown) {
      this.map.removeLayer(this.layer);
      this.isShown = false;
      handleEvent('hide', this);
    }
    return this;
  };

  Overlay.prototype.toggle = function (isShown) {
    if (typeof isShown !== 'boolean') {
      isShown = !this.isShown;
    }
    if (isShown) {
      this.show();
    } else {
      this.hide();
    }
    return this;
  };

  Overlay.prototype.on = function(eventName, handler) {
    this.eventHandlers[eventName] = handler;
    return this;
  };

  function handleEvent(eventName, overlay) {
    var handler = overlay.eventHandlers[eventName];
    if (handler) {
      handler(overlay);
    }
  };

  return Overlay;
}());
